var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup noselect"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Vyberte znalca")]), _c('button', {
    staticClass: "button-primary-expert w-button",
    on: {
      "click": _vm.assignExpertToClient
    }
  }, [_vm._v("Priradiť")])]), _vm._l(_vm.experts, function (expert, key) {
    return _c('div', {
      key: key,
      staticClass: "popup-block pointer",
      on: {
        "click": function click($event) {
          return _vm.selectExpert(key);
        }
      }
    }, [_c('div', {
      staticClass: "vertical-align-divs flex-row"
    }, [_c('div', {
      staticClass: "user-relation"
    }, [_c('div', [_vm.expertSelected === key ? _c('img', {
      staticClass: "nav-link-icon filter-primary",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f25_icons8-check.svg",
        "alt": ""
      }
    }) : _vm._e(), expert.profile_image ? _c('img', {
      staticClass: "broker-image",
      attrs: {
        "src": expert.profile_image,
        "loading": "lazy",
        "sizes": "100vw",
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "broker-image",
      attrs: {
        "src": require("@/images/Michal-Voronič.jpg"),
        "loading": "lazy",
        "sizes": "100vw",
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "text-block"
    }, [_c('div', {
      staticClass: "text--black"
    }, [_vm._v(" " + _vm._s(expert.first_name) + " " + _vm._s(expert.last_name) + " ")])])]), _c('div', {
      staticClass: "cta-text"
    }, [_vm._v("1")])])]);
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }